/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function PlaylistNext(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'PlaylistNext',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 13 * scale,
      viewBox: '0 0 12 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"d":"M6 6h2v12H6zm3.5 6 8.5 6V6z","id":"wf-svg-PlaylistNext-__a"})),createElement('g', {"transform":"matrix(-1 0 0 1 18 -6)","fill":"currentColor","fillRule":"evenodd","opacity":".7"},createElement('use', {"filter":"url(#wf-svg-PlaylistNext-__a)","xlinkHref":"#wf-svg-PlaylistNext-__a"}),createElement('use', {"xlinkHref":"#wf-svg-PlaylistNext-__a"}),createElement('use', {"filter":"url(#wf-svg-PlaylistNext-__wf-svg-playlist-next-c)","xlinkHref":"#wf-svg-PlaylistNext-__a"})))
}
